import { Dialog } from '@mui/material';
import { X } from 'feather-icons-react/build/IconComponents';
import React, { useState } from 'react';
import { Transition } from './Transition';
import { t } from 'i18next';
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';
import TextareaComponent from '../Component/FormInput/TextareaComponent';

const SourceCode = ({ open, htmlCode, closeCode, saveHTML }) => {
    const [html, setHtml] = useState({ htmlPP: open, code: htmlCode });
    const [isChange, setIsChange] = useState(false);

    const handleClose = () => {
        if (isChange && window.confirm("Are You Sure to Leave?. Your recent changes will not be included.")) {
            closeCode();
            setIsChange(false);
        } else {
            closeCode();
        }
    };

    return (
        <Dialog
            open={html?.htmlPP}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <div className='w-full md:w-[35rem] p-5 rounded-[6px] secondary-bg-color shadow dark:bg-gray-700'>
                <label className='flex items-center justify-between text-primary text-md font-medium'>
                    {t('lang_source_code')}
                    <button onClick={(e) => {
                        e.preventDefault();
                        if (isChange && window.confirm("Are You Sure to Leave?. Your recent changes will not be included.")) {
                            closeCode();
                            setIsChange(false)
                        } else {
                            closeCode()
                        }
                    }} className="close-btn">
                        <X className="w-4 h-4" />
                    </button>
                </label>
                <hr className='my-2 main-border-color' />
                <div>
                    <TextareaComponent
                        rows={16}
                        value={html?.code}
                        onChange={(e) => { setHtml({ ...html, code: e.target.value }); setIsChange(true); }}
                        placeholder='<p>Code here</p>'
                    />
                </div>
                <ButtonComponent
                    variant="primary"
                    className='w-full'
                    onClick={() => saveHTML(html?.code)}
                >
                    {t('lang_Edit_Source_Code')}
                </ButtonComponent>
            </div>
        </Dialog >
    );
};

export default SourceCode;